import { render } from "./Percentage-bars.vue?vue&type=template&id=2f8c701c"
import script from "./Percentage-bars.vue?vue&type=script&lang=js"
export * from "./Percentage-bars.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/charts/Percentage-bars.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f8c701c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f8c701c', __exports__)) {
    api.reload('2f8c701c', __exports__)
  }
  
  module.hot.accept("./Percentage-bars.vue?vue&type=template&id=2f8c701c", () => {
    api.rerender('2f8c701c', render)
  })

}


export default __exports__